import templateUrl from 'servicestack/tags/tags-badges.htm'
import basicController from 'servicestack/basic.controller.properties'

export class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
    }
}

export default {
    bindings: {
        badges: '<'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};